import classNames from 'classnames';
import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { getFormValues, reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';
import { getOpenedQuarters } from '../../../lib/openedQuarters';
import { toastr } from 'react-redux-toastr';
// actions
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';
import { booksCreate } from '../../../actions/booksActions';
import { initialize } from 'redux-form/immutable';

// components
import { Field } from 'redux-form/immutable';
import { Button, Checkbox } from '../../shared/_form';
import Spinner from '../../shared/_Spinner';
import { Tooltip } from '../../shared/_tooltip';

// constants
const FORM_NAME   = 'openBooks';
const TOOLTIP_ID  = 'openBooksTooltip';

class OpenBooksTooltip extends React.Component {
  static propTypes = {
    appointment:  PropTypes.instanceOf(Immutable.Map),
    formValues:   PropTypes.instanceOf(Immutable.Map),
    hideTooltip:  PropTypes.func.isRequired,
    initForm:     PropTypes.func.isRequired,
    openBooks:    PropTypes.func.isRequired,
    openedQuarters:   PropTypes.instanceOf(Immutable.List),
    showTooltip:  PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map({
      openBooks: Immutable.Map()
    }),
    availableOpenedQuarters: 0
   };
  }
  componentDidMount() {
    this._initForm();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.openedQuarters.size !== this.props.openedQuarters.size) {
      this._initForm();
    }
  }

  render() {
    const { hideTooltip, showTooltip } = this.props;

    return (
      <div className='tooltip-button-container'>
        <div className='tooltip-button'>
          <Button className='form__button--green manager__calendar-index__header__button manager__calendar-index__open-books-tooltip-button'
            onClick={ showTooltip }>
            Open Books
          </Button>
          <Tooltip className='manager__calendar-index__open-books-tooltip'
            header='Choose Quarter To Open:'
            id={ TOOLTIP_ID }>
            <Spinner enabled={ this._loadingForm() }>
              <form onSubmit={ this._handleSubmit }>
                { this._renderForm() }

                <div className='form__submit'>
                  <Button className='form__button form__button--purple'
                    disabled={ this._loadingSubmit() }
                    onClick={ hideTooltip }
                    type='button'>
                    Cancel
                  </Button>
                  <Button className='form__button form__button--green'
                    loading={ this._loadingSubmit() }
                    type='submit'>
                    Save
                  </Button>
                </div>
              </form>
            </Spinner>
          </Tooltip>
        </div>
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _getQuarterLabel(date) {
    return `Q${date.format('Q')} ${date.format('YYYY')}: ${date.startOf('quarter').format('MMM D')} - ${date.endOf('quarter').format('MMM D')}`;
  }

  _handleSubmit(e) {
    e.preventDefault();

    const { openBooks, formValues } = this.props;

    const quarters    = [];
    const openedBooks = this.state.data.get('openBooks');

    formValues.map((value, key) => {
      if (value) {
        const date = moment(key, 'YYYY-MM-DD');
        const open = openedBooks.get(key);

        if (!open) {
          quarters.push({
            number: date.format('Q'),
            year:   date.format('YYYY')
          });
        }
      }
    });

    openBooks({ quarters: quarters, tooltipId: TOOLTIP_ID });
  }

  _initForm() {
    const { openedQuarters, initForm } = this.props;
    const openedBooks = this.state.data.get('openBooks');
    const quarters = openedQuarters.toJSON();
    const quartersArray = [
      {
        start:  moment().startOf('quarter'),
        end:    moment().endOf('quarter')
      },
      {
        start:  moment().add(1, 'Q').startOf('quarter'),
        end:    moment().add(1, 'Q').endOf('quarter')
      }, {

        start:  moment().add(2, 'Q').startOf('quarter'),
        end:    moment().add(2, 'Q').endOf('quarter')
      },
      {
        start:  moment().add(3, 'Q').startOf('quarter'),
        end:    moment().add(3, 'Q').endOf('quarter')
      }
    ];

    getOpenedQuarters(quartersArray, quarters).then((openedQuartersList) => {
      this.setState({
        data: this.state.data.set('openBooks', openedBooks.merge(openedQuartersList)),
        availableOpenedQuarters: 4 - Object.keys(openedQuartersList).length
      });
      initForm(openedQuartersList);
    });
  }

  _loadingForm() {
    const { appointment } = this.props;

    const loading = appointment.get('loading');
    const data    = appointment.get('data');

    return loading && !data;
  }

  _loadingSubmit() {
    const { appointment } = this.props;

    return appointment.get('loading');
  }

  _handleChangeCheckBox = (input, e) => {
    const end_date = moment(input.name)

    if (end_date.diff(new Date, 'month') <= 0) {
      return input.onChange(e)
    } else {
      return toastr.error('The quarter can only be opened prior to one month from now. Please try again later');
    }
}

  _renderCheckbox = ({ input, meta, ...rest }) => {
    const value         = typeof input.value === 'boolean' ? input.value : false,
          _handleChange = (event) => this._handleChangeCheckBox(input, event);

    return <Checkbox checked={ input.value }
      { ...input }
      { ...rest }
      onChange={ _handleChange }
      value={ value } />;
  }

  _renderForm() {
    const elements  = [];
    const openBooks = this.state.data.get('openBooks');

    for (let i = 0; i < 4; i++) {
      const date    = moment().add(i, 'Q');
      const fieldId = date.startOf('quarter').format('YYYY-MM-DD');
      const open    = openBooks.get(fieldId) === true;

      elements.push(
        <div className={ classNames('form__group tooltip__form__group manager__calendar-index__open-books-tooltip__form-group', { 'form__group--disabled': open }) } key={ i }>
          <Field component={ this._renderCheckbox } disabled={ open } id={ fieldId } name={ fieldId } type='checkbox' />{ this._getQuarterLabel(date) }
        </div>
      );
    }

    return elements;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment:  state.get('appointment'),
    openedQuarters:  state.getIn(['currentUser', 'data', 'office', 'openedQuarters']),
    formValues:   getFormValues(FORM_NAME)(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: () => {
      dispatch(tooltipHide({ id: TOOLTIP_ID }));
    },

    initForm: (form) => {
      dispatch(initialize(FORM_NAME, form, { keepDirty: true }));
    },

    openBooks: (params) => {
      dispatch(booksCreate(params));
    },

    showTooltip: () => {
      dispatch(tooltipShow({ id: TOOLTIP_ID }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME }
  )(OpenBooksTooltip)
);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_OpenBooksTooltip.jsx